<div
  class="template__wrapper"
  [class.for-print]="isPrintView"
  [class.animated]="animated$ | async"
  [innerHTML]="generatedBody"
></div>
